import React, { useState, useEffect } from 'react'
import { useParams, useHistory, useLocation } from 'react-router-dom'
import './VolunteerAttemptView.css'
import LoadingScreen from '../components/LoadingScreen'

const VolunteerAttemptView = () => {
  const { attemptId } = useParams()
  const history = useHistory()
  const location = useLocation()
  const [attempt, setAttempt] = useState(location.state?.attempt || null)
  const [loading, setLoading] = useState(!attempt)
  const [error, setError] = useState('')

  useEffect(() => {
    if (!attempt) {
      fetchAttempt()
    }
  }, [attemptId])

  const fetchAttempt = async () => {
    try {
      const token = localStorage.getItem('access_token')
      const response = await fetch(`/api/volunteer/test-attempts/${attemptId}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })

      if (response.ok) {
        const data = await response.json()
        setAttempt(data.attempt)
      } else {
        setError('Failed to load attempt details')
      }
    } catch (err) {
      setError('Network error')
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return <LoadingScreen message="Loading Attempt Details" />
  }

  if (error || !attempt) {
    return (
      <div className="volunteer-attempt-view-container">
        <div className="error">{error || 'Attempt not found'}</div>
        <button onClick={() => history.push('/volunteer/attempts')}>Back to Attempts</button>
      </div>
    )
  }

  return (
    <div className="volunteer-attempt-view-container">
      <header className="page-header">
        <h1>Attempt Details</h1>
        <button onClick={() => history.push('/volunteer/attempts')}>← Back</button>
      </header>

      <main className="attempt-details">
        <div className="attempt-info-section">
          <h2>Test Information</h2>
          <p><strong>Test:</strong> {attempt.test_title}</p>
          <p><strong>Student:</strong> {attempt.student_name} ({attempt.student_email})</p>
          <p><strong>Score:</strong> {attempt.percentage}%</p>
          <p><strong>Status:</strong> <span className={`status-badge status-${attempt.status}`}>{attempt.status}</span></p>
          <p><strong>Started:</strong> {new Date(attempt.start_time).toLocaleString()}</p>
          {attempt.submitted_at && (
            <p><strong>Submitted:</strong> {new Date(attempt.submitted_at).toLocaleString()}</p>
          )}
        </div>

        {attempt.violations && attempt.violations.length > 0 && (
          <div className="violations-section">
            <h2>Violations</h2>
            {attempt.violations.map((violation, index) => (
              <div key={index} className="violation-item">
                <p><strong>Type:</strong> {violation.type}</p>
                <p><strong>Severity:</strong> {violation.severity}</p>
                <p><strong>Message:</strong> {violation.message}</p>
                {violation.timestamp && (
                  <p><strong>Time:</strong> {new Date(violation.timestamp).toLocaleString()}</p>
                )}
              </div>
            ))}
          </div>
        )}

        {attempt.answers && Object.keys(attempt.answers).length > 0 && (
          <div className="answers-section">
            <h2>Answers (Read-Only)</h2>
            <p className="note">Answers are displayed for review purposes only</p>
            {Object.entries(attempt.answers).map(([questionId, answer]) => (
              <div key={questionId} className="answer-item">
                <p><strong>Question {questionId}:</strong> {answer}</p>
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  )
}

export default VolunteerAttemptView

